module.exports = __webpack_public_path__ + "37fe18ca88ca666ec02e4cf8f7711ec5.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/bookshelves/bookshelf-gamer.png
// module id = 2773
// module chunks = 0